// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;When the wicked, even my enemies and my foes,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;came upon me to eat up my flesh,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;they stumbled and fell.<br> </p> </div></div>";
// Exports
module.exports = code;